import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { resolveCdnAssetUrl } from "../../utils/cdnAssetUrl";

export function BentoImages() {
  const bentoImagesRow1 = [
    resolveCdnAssetUrl("bentoImages/bento1.png"),
    resolveCdnAssetUrl("bentoImages/bento2.jpg"),
    resolveCdnAssetUrl("bentoImages/bento3.jpg"),
  ];
  const bentoImagesRow2 = [
    resolveCdnAssetUrl("bentoImages/bento4.jpg"),
    resolveCdnAssetUrl("bentoImages/bento5.jpg"),
  ];
  return (
    <Stack width={"100%"} alignItems={"center"}>
      <Stack maxWidth={{ sm: 500, md: "100%" }} gap={2}>
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: {
              sm: "1fr",
              md: "repeat(3, 1fr)",
            },
          }}
        >
          {bentoImagesRow1.map((image, index) => (
            <Box
              key={`bento-images-row-1-image-${index.toString()}`}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                component="img"
                alt={`Top row Bento Image ${(index + 1).toString()}`}
                src={image}
                sx={{
                  width: "100%",
                  height: "100%",
                  aspectRatio: "1 / 1",
                  objectFit: "cover",
                  borderRadius: 2,
                }}
              />
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: {
              sm: "1fr",
              md: "repeat(2, 1fr)",
            },
          }}
        >
          {bentoImagesRow2.map((image, index) => (
            <Box
              key={`bento-images-row-2-image-${index.toString()}`}
              sx={{
                display: "flex",
                justifyContent: "center",
                height: { md: "300px" },
              }}
            >
              <Box
                component="img"
                alt={`Bottom row Bento Image ${(index + 1).toString()}`}
                src={image}
                sx={{
                  width: "100%",
                  height: "100%",
                  aspectRatio: "1 / 1",
                  objectFit: "cover",
                  borderRadius: 2,
                }}
              />
            </Box>
          ))}
        </Box>
      </Stack>
    </Stack>
  );
}
